import { ApartmentStatusIcon } from "./components/ApartmentStatusIcon";
import { IconEnter } from "./components/IconEnter";
import { IconLock } from "./components/IconLock";
import { IconUnlock } from "./components/IconUnlock";
import { KeypadButton } from "./components/KeypadButton";
import { WidgetFrame } from "./components/WidgetFrame";
import { ApartmentStatus, IntercomWidgetVariant } from "./const";

export type AccessWidgetProps = {
  variant: IntercomWidgetVariant;
  status: ApartmentStatus;
  onLock: () => void;
  onUnlock: () => void;
  onEnter: () => void;
};

const variants = {
  [IntercomWidgetVariant.Simple]: {
    statusTop: 44,
    keypadTop: 105,
  },
  [IntercomWidgetVariant.Modern]: {
    statusTop: 36,
    keypadTop: 125,
  },
  [IntercomWidgetVariant.Elite]: {
    statusTop: 44,
    keypadTop: 105,
  },
};

export default function AccessWidget({
  variant,
  status,
  onLock,
  onUnlock,
  onEnter,
}: AccessWidgetProps) {
  const { statusTop, keypadTop } = variants[variant];

  return (
    <WidgetFrame size="sm" variant={variant}>
      <div className="absolute left-1/2 -translate-x-1/2" style={{ top: `${statusTop}px` }}>
        <ApartmentStatusIcon status={status} />
      </div>

      <div
        className="absolute flex left-0 justify-center px-8 w-full text-[#323232]"
        style={{ top: `${keypadTop}px` }}
      >
        <KeypadButton variant={variant} onClick={onUnlock}>
          <IconUnlock size={20} />
        </KeypadButton>

        <KeypadButton variant={variant} onClick={onLock}>
          <IconLock size={20} />
        </KeypadButton>

        <KeypadButton variant={variant} onClick={onEnter}>
          <IconEnter size={20} />
        </KeypadButton>
      </div>
    </WidgetFrame>
  );
}
